// extracted by mini-css-extract-plugin
module.exports = {"scrollButton":"ScrollButton_scrollButton__J__zJ","inZoomModal":"ScrollButton_inZoomModal__Arzi_","previous":"ScrollButton_previous__mo7D1","next":"ScrollButton_next__ZINZF"};